import React from "react";
import { useTranslation } from "react-i18next";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import styles from "./BecomeSeller.module.scss";

const BecomeSeller = () => {
  const { t } = useTranslation("translation");

  const getTranslatedArray = <T,>(key: string): T[] => {
    const result = t(key, { returnObjects: true });
    return Array.isArray(result) ? (result as T[]) : [];
  };

  const getTranslatedFeatures = () =>
    getTranslatedArray<{
      icon: string;
      title: string;
      description: string;
    }>("become_seller_page.why_luxmart.features");

  const getTranslatedSteps = () =>
    getTranslatedArray<{
      number: string;
      title: string;
      description: string;
    }>("become_seller_page.how_it_works.steps");

  const getTranslatedRequirements = () =>
    getTranslatedArray<{
      icon: string;
      title: string;
      description: string;
    }>("become_seller_page.requirements.items");

  const getTranslatedBenefits = () =>
    getTranslatedArray<{
      icon: string;
      text: string;
    }>("become_seller_page.benefits.items");

  return (
    <div className="container">
      <div className={styles.becomeSeller_container}>
        <TitleUpdater title={t("become_seller_page.title")} />
        <section className={styles.sell_hero}>
          <div className={styles.hero_content}>
            <h3>{t("become_seller_page.hero.title")}</h3>
          </div>
        </section>

        <div className={styles.sell_content}>
          <section className={styles.sell_section}>
            <h2 className={styles.section_title}>
              {t("become_seller_page.why_luxmart.title")}
            </h2>
            <div className={styles.features_grid}>
              {getTranslatedFeatures().map((feature, index) => (
                <div key={index} className={styles.feature_card}>
                  <div className={styles.feature_icon}>{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section className={`${styles.sell_section} ${styles.steps_section}`}>
            <h2 className={styles.section_title}>
              {t("become_seller_page.how_it_works.title")}
            </h2>
            <p className={styles.section_subtitle}>
              {t("become_seller_page.how_it_works.subtitle")}
            </p>
            <div className={styles.steps_container}>
              {getTranslatedSteps().map((step, index) => (
                <div key={index} className={styles.step_card}>
                  <div className={styles.step_number}>{step.number}</div>
                  <div className={styles.step_content}>
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className={styles.sell_section}>
            <h2 className={styles.section_title}>
              {t("become_seller_page.requirements.title")}
            </h2>
            <div className={styles.requirements_grid}>
              {getTranslatedRequirements().map((req, index) => (
                <div key={index} className={styles.requirement_card}>
                  <div className={styles.req_icon}>{req.icon}</div>
                  <h3>{req.title}</h3>
                  <p>{req.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section
            className={`${styles.sell_section} ${styles.benefits_section}`}
          >
            <h2 className={styles.section_title}>
              {t("become_seller_page.benefits.title")}
            </h2>
            <div className={styles.benefits_grid}>
              {getTranslatedBenefits().map((benefit, index) => (
                <div key={index} className={styles.benefit_item}>
                  <span className={styles.benefit_icon}>{benefit.icon}</span>
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
          </section>

          <section
            className={`${styles.sell_section} ${styles.cta_section_main}`}
          >
            <div className={styles.cta_content}>
              <h2>{t("become_seller_page.cta.title")}</h2>
              <p>{t("become_seller_page.cta.subtitle")}</p>
              <a
                href={"https://store.luxmart.site/"}
                className={styles.cta_button_large}
                target="_blank"
                rel="noreferrer"
              >
                {t("become_seller_page.cta.button")}
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BecomeSeller;
